/*!
 * Copyright (c) 2022 WEBLIFE
 *
 * Permission is granted to use this file for the period specified in the contract 
 * between WEBLIFE and the client. Usage of this file beyond the contract period 
 * is strictly prohibited unless an extended license or written permission is obtained.
 *
 * Modifying or editing this file without prior written consent from WEBLIFE 
 * is not permitted.
 *
 * THE FILE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, 
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A 
 * PARTICULAR PURPOSE AND NONINFRINGEMENT.
 */
var __defProp = Object.defineProperty,
  __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: value
  }) : obj[key] = value,
  __publicField = (obj, key, value) => __defNormalProp(obj, "symbol" != typeof key ? key + "" : key, value);
(() => {
  class WLSliderSwiper extends HTMLElement {
    constructor() {
      super(), __publicField(this, "sliderData", null), __publicField(this, "swiper", null), __publicField(this, "countdownBar", null), __publicField(this, "initializationPromise", null), __publicField(this, "originalSlidesCount", 0), this.initSlider().then((() => {
        this.classList.add("is-initialized")
      })), this.addEventListeners(), this.addStyles()
    }
    async initSlider() {
      if (this.sliderData = this.extractSliderData(), !this.sliderData) return;
      const mainSwiper = this.querySelector(".main-swiper");
      if (mainSwiper && this.sliderData.loop) {
        const swiperWrapper = mainSwiper.querySelector(".swiper-wrapper");
        if (swiperWrapper) {
          const originalSlides = swiperWrapper.querySelectorAll(".swiper-slide");
          this.originalSlidesCount = originalSlides.length
        }
      }
      this.sliderData.loop && this.createLoopClones();
      const sliderOptions = this.setOptions(this.sliderData);
      this.swiper = new window.Swiper(`#${this.sliderData.class} .main-swiper`, sliderOptions)
    }
    createLoopClones() {
      const mainSwiper = this.querySelector(".main-swiper");
      if (!mainSwiper) return;
      const swiperWrapper = mainSwiper.querySelector(".swiper-wrapper");
      if (!swiperWrapper) return;
      const slides = swiperWrapper.querySelectorAll(".swiper-slide");
      slides.length < 2 ||  Array.from(slides).reverse().forEach((slide => {
        const clonedSlide = slide.cloneNode(!0);
        clonedSlide.classList.add("swiper-slide-duplicate"), swiperWrapper.insertBefore(clonedSlide, swiperWrapper.firstChild)
      }))
    }
    initCountdownBar(swiper) {
      var _a;
      (null == (_a = this.sliderData) ? void 0 : _a.autorotate) && (this.countdownBar = this.querySelector(".js-countdown-bar"), this.startCountdownBar(swiper))
    }
    startCountdownBar(swiper) {
      if (!this.countdownBar) return;
      const duration = "object" == typeof swiper.params.autoplay ? swiper.params.autoplay.delay : 5e3;
      this.countdownBar.style.transition = `width ${duration}ms linear`, this.countdownBar.style.width = "100%"
    }
    resetCountdownBar() {
      this.countdownBar && (this.countdownBar.style.transition = "none", this.countdownBar.style.width = "0%", setTimeout((() => {
        this.startCountdownBar(this.swiper)
      }), 50))
    }
    updatePagination(swiper) {
      var _a;
      if (null == (_a = null == this ? void 0 : this.sliderData) ? void 0 : _a.loop) {
        const slideElement = this.querySelectorAll(".swiper-slide"),
          paginationElement = this.querySelectorAll(".swiper-pagination-bullet");
        if (slideElement)
          if (swiper.realIndex > this.originalSlidesCount - 1) {
            const realIndex = swiper.realIndex - this.originalSlidesCount;
            paginationElement.forEach(((bullet, idx) => {
              idx == realIndex ? bullet.classList.add("swiper-pagination-custom-active") : bullet.classList.remove("swiper-pagination-custom-active")
            }))
          } else paginationElement.forEach(((bullet, idx) => {
            idx != swiper.realIndex && bullet.classList.remove("swiper-pagination-custom-active")
          }))
      }
    }
    extractSliderData() {
      try {
        const preview = window.innerWidth <= 989 ? 1 : parseFloat(this.dataset.sliderPreview || "1");
        return {
          speed: parseInt(this.dataset.sliderSpeed || "3000"),
          loop: "true" === this.dataset.sliderLoop,
          arrow: "true" === this.dataset.sliderArrow,
          autoloop: "true" === this.dataset.sliderAutoloop,
          autorotate: "true" === this.dataset.sliderAutorotate,
          autoloopSpeed: parseInt(this.dataset.sliderAutoloopSpeed || "1000"),
          preview: preview,
          pagination: this.dataset.sliderPagination || "none",
          thumb: "true" === this.dataset.sliderThumb,
          thumbSlide: "true" === this.dataset.sliderThumbSlide,
          thumbGrid: parseInt(this.dataset.sliderThumbGrid || "3"),
          thumbPreview: parseInt(this.dataset.sliderThumbPreview || "3"),
          fade: "true" === this.dataset.sliderFade,
          class: this.dataset.class || "",
          designMode: "true" === this.dataset.designMode,
          parallax: "true" === this.dataset.sliderParallax,
          spaceBetween: parseInt(this.dataset.spaceBetweenSlides || "0"),
          centeredSlides: preview % 1 == .5 || "true" === this.dataset.sliderLoop
        }
      } catch (error) {
        return null
      }
    }
    setOptions(data) {
      const options = {
        speed: data.speed,
        loop: data.loop,
        slidesPerView: data.preview,
        parallax: data.parallax,
        mousewheel: {
          enabled: !!data.designMode,
          forceToAxis: !!data.designMode,
          invert: !!data.designMode,
          thresholdDelta: 20
        },
        on: {
          init: swiper => {
            swiper.el.classList.add("image-loaded"), this.initCountdownBar(swiper)
          },
          slideChangeTransitionStart: swiper => {
            this.updatePagination(swiper), this.resetCountdownBar()
          },
          slideChange: swiper => {
            this.updatePagination(swiper), this.resetCountdownBar()
          }
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          750: {
            slidesPerView: data.preview,
            spaceBetween: data.spaceBetween
          }
        }
      };
      if ("none" !== data.pagination) {
        const paginationOptions = {
          el: ".swiper-pagination",
          type: data.pagination,
          renderBullet: data.loop ? (index, className) => index < this.originalSlidesCount ? `<span class="${className}"></span>` : "" : (_, className) => `<span class="${className}"></span>`,
          clickable: !0,
          dynamicBullets: !1
        };
        options.pagination = paginationOptions
      }
      if (data.autoloop) {
        const autoplayOptions = {
          delay: data.autoloopSpeed,
          disableOnInteraction: !0,
          pauseOnMouseEnter: !1,
          reverseDirection: !1,
          stopOnLastSlide: !1,
          waitForTransition: !0
        };
        options.autoplay = autoplayOptions
      }
      if (data.arrow) {
        const navigationOptions = {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        };
        options.navigation = navigationOptions
      }
      if (data.fade && (options.effect = "fade", options.fadeEffect = {
          crossFade: !0
        }), data.thumb && data.thumbSlide) {
        const thumbsSwiper = new window.Swiper(`#${data.class} .swiper-thumbs`, {
          slidesPerView: data.thumbPreview,
          freeMode: !0,
          watchSlidesProgress: !0
        });
        options.thumbs = {
          swiper: thumbsSwiper
        }
      }
      return data.spaceBetween&&(options.spaceBetween=data.spaceBetween),data.centeredSlides&&(options.centeredSlides=data.centeredSlides,options.centeredSlidesBounds=!1),data.loop&&(options.slideToClickedSlide=!0),options
    }
    addEventListeners() {
      document.addEventListener("shopify:section:load", (event => {
        const section = this.closest("section");
        section && event.target && section.contains(event.target) && (this.swiper && (this.swiper.destroy(!0, !0), this.swiper = null, this.dataset.animation = "false"), this.countdownBar && (this.countdownBar.style.width = "0%", this.countdownBar = null), this.initializationPromise = new Promise((resolve => {
          Promise.resolve().then((() => {
            this.sliderData = null, this.initSlider().then((() => {
              this.addStyles(), resolve()
            }))
          }))
        })))
      })), document.addEventListener("shopify:block:select", (async event => {
        const blockId = event.detail.blockId,
          blockElement = document.getElementById(`slide-item--${blockId}`);
        if (this.initializationPromise && await this.initializationPromise, blockElement && this.swiper) {
          const slideIndex = Array.from(this.swiper.slides).findIndex((slide => slide.id === `slide-item--${blockId}`)); - 1 !== slideIndex && (this.swiper.slideTo(slideIndex, 0, !1), this.swiper.autoplay && this.swiper.autoplay.stop())
        }
      }))
    }
    addStyles() {
      const swiperContainer = this.querySelector(".swiper"),
        swiperImage = this.querySelectorAll(".swiper-slide__media"),
        textBelowImage = this.querySelector(".swiper-slide__mobile-grid");
      let swiperHeight = 0,
        swiperImageHeight = 0;
      if (window.innerWidth <= 749 && textBelowImage) {
        swiperContainer && (swiperHeight = swiperContainer.clientHeight), swiperImage && swiperImage.forEach((element => {
          element.clientHeight > swiperImageHeight && (swiperImageHeight = element.clientHeight)
        }));
        const paginationCountdownElement = this.querySelector(".swiper-pagination-countdown");
        paginationCountdownElement && (paginationCountdownElement.style.bottom = swiperHeight - swiperImageHeight - 1 + "px")
      }
    }
  }
  customElements.get("wl-slider-swiper") || customElements.define("wl-slider-swiper", WLSliderSwiper)
})();